
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/team-membership",
      function () {
        return require("private-next-pages/team-membership/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/team-membership"])
      });
    }
  